'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagPnAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M28 0H0V20H28V0Z", fill: "white" }),
      /* @__PURE__ */ jsx("path", { d: "M28 0H0V20H28V0Z", fill: "#07319C" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M17.3333 12.6667V8.67953C17.3333 8.30424 17.6198 8 17.9969 8H23.3364C23.7029 8 24 8.30215 24 8.67953V12.6667C24 16 20.6666 17.3334 20.6666 17.3334C20.6666 17.3334 17.3333 16 17.3333 12.6667Z",
          fill: "#1F8BDE"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M16.6665 16L20.6665 8L24.6665 16V18.6667H16.6665V16Z",
          fill: "#F7E14A"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M17.3333 16.1574V18H24V16.1574L20.6666 9.49072L17.3333 16.1574Z",
          fill: "#4B8C36"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M23.9999 12.6667C23.9999 13.223 23.907 13.7236 23.7523 14.1716L24.6665 16V18.6667H16.6665V16L17.5808 14.1716C18.353 16.4079 20.6665 17.3334 20.6665 17.3334C20.6665 17.3334 23.9999 16 23.9999 12.6667Z",
          fill: "#07319C"
        }
      ),
      /* @__PURE__ */ jsx("rect", { width: 12, height: 8, fill: "#001C5B" }),
      /* @__PURE__ */ jsx("path", { d: "M11.1 8L0 1.3V0H0.9L12 6.6V8H11.1Z", fill: "white" }),
      /* @__PURE__ */ jsx("path", { d: "M0.9 8L12 1.3V0H11.1L0 6.6V8H0.9Z", fill: "white" }),
      /* @__PURE__ */ jsx("path", { d: "M2.8 2.70003L0 1.00003V0.400024L3.8 2.70003H2.8Z", fill: "#CA0028" }),
      /* @__PURE__ */ jsx("path", { d: "M9.2 5.29997L12 6.99997V7.59998L8.2 5.29997H9.2Z", fill: "#CA0028" }),
      /* @__PURE__ */ jsx("path", { d: "M8.29999 2.7L12 0.4V0H11.6L7.29999 2.7H8.29999Z", fill: "#CA0028" }),
      /* @__PURE__ */ jsx("path", { d: "M3.70001 5.3L0 7.6V8H0.4L4.70001 5.3H3.70001Z", fill: "#CA0028" }),
      /* @__PURE__ */ jsx("rect", { x: 4.69995, width: 2.6, height: 8, fill: "white" }),
      /* @__PURE__ */ jsx(
        "rect",
        {
          y: 5.29999,
          width: 2.6,
          height: 12,
          transform: "rotate(-90 0 5.29999)",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx("rect", { x: 5.19995, width: 1.6, height: 8, fill: "#CA0028" }),
      /* @__PURE__ */ jsx(
        "rect",
        {
          y: 4.79999,
          width: 1.6,
          height: 12,
          transform: "rotate(-90 0 4.79999)",
          fill: "#CA0028"
        }
      )
    ]
  }
);
const VpFlagPnAsset = forwardRef(FlagPnAsset);

export { VpFlagPnAsset as default };
